
export const AD_PLACEMENTS = [
  { key: "HOMEPAGE", label: "Homepage" },
  { key: "JOB_LISTING_LOCUM", label: "Job Listing - Locum" },
  { key: "JOB_LISTING_PERMANENT", label: "Job Listing - Permanent" },
  { key: "JOB_LISTING_INTERNATIONAL", label: "Job Listing - International" },
  { key: "JOB_DETAILS_LOCUM", label: "Job Details - Locum" },
  { key: "JOB_DETAILS_PERMANENT", label: "Job Details - Permanent" },
  { key: "JOB_DETAILS_INTERNATIONAL", label: "Job Details - International" },
];

// Ad type options for the "Google Ads" / "Jobizo Ads" choice beside Upload.
export const AD_TYPE = {
  GOOGLE: "google",
  JOBIZO: "jobizo",
};
